import React from 'react';
import useAddSiteToPlatform from '../../hooks/useAddSiteToPlatform';
import { HabitatInsightsSamplesAddSite } from '../habitat-insights-samples/HabitatInsightsSamplesAddSite';
import ReviewAndSubmitAddSite from '../review-and-submit/ReviewAndSubmitAddSite';

type HabitatInsightsUploadAddSiteProps = {
    isDisabled?: boolean;
};

export const HabitatInsightsUploadAddSite = ({ isDisabled = false }: HabitatInsightsUploadAddSiteProps) => {
    const { formState } = useAddSiteToPlatform();
    return (
        <>
            <div className='flex flex-col gap-[25px]'>
                <div className='w-full flex flex-col'>
                    <div className='text-black text-[17px] border-b border-[#4a4a4a] mb-[40px]'>Remote sensing - Areas of interest</div>
                    <HabitatInsightsSamplesAddSite isDisabled={isDisabled} />
                </div>
            </div>
            {formState.uploadedFileContent && (
                <div className='mt-6'>
                    <ReviewAndSubmitAddSite />
                </div>
            )}
        </>
    );
};

export default HabitatInsightsUploadAddSite;
